import { fetcher } from "helpers/fetcher";

import {
  TGetStaffInterviewResultListReq,
  TGetStaffInterviewResultListRes,
} from "api/management/types";
import { API_HEADER } from "api/constants";
import { ENDPOINT } from "api/endpoint";

export const getStaffInterviewResultList = async (
  payload: TGetStaffInterviewResultListReq
) => {
  return await fetcher<
    TGetStaffInterviewResultListRes,
    TGetStaffInterviewResultListReq["data"]
  >(ENDPOINT.MANAGEMENT.GET_STAFF_INTERVIEW_RESULT_LIST, {
    headers: {
      [API_HEADER.VERSION]:
        ENDPOINT.MANAGEMENT.GET_STAFF_INTERVIEW_RESULT_LIST.version,
      [API_HEADER.BU_ID]: payload.idBu,
    },
    urlData: {
      idStaff: payload.idStaff,
    },
    data: payload.data,
  });
};

export const queryGetStaffInterviewResultList = async (
  payload: TGetStaffInterviewResultListReq
): Promise<TGetStaffInterviewResultListRes> => {
  const res = await getStaffInterviewResultList(payload);
  return res.data;
};

queryGetStaffInterviewResultList._key = (
  payload: TGetStaffInterviewResultListReq
) => [ENDPOINT.MANAGEMENT.GET_STAFF_INTERVIEW_RESULT_LIST.url, payload];
